import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { styled } from '@mui/material';

import { VizType } from 'business/definitions';
import { useIsExploreUser } from 'hooks/client';
import AddButton from 'ui/Buttons/AddButton';
import HeaderLayout from 'ui/HeaderLayout/HeaderLayout';
import FilterBar from './FilterBar/FilterBar';
import { IndicatorFilterT } from './helpers/types';
import IndicatorsBanners from './IndicatorsBanners/IndicatorsBanners';

const StyIndicatorsPageContent = styled('div', {
    name: 'StyIndicatorsPageContent',
})(({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(5),
    overflowY: 'auto',
    padding: theme.spacing(5),
}));

const StyIndicatorsContainer = styled('div', {
    name: 'StyIndicatorsContainer',
})({
    display: 'flex',
    flexDirection: 'column',
    overflow: 'hidden',
    width: '100%',
});

const Indicators = (): JSX.Element => {
    const { t } = useTranslation();

    const [aggregationsFilter, setAggregationsFilter] = useState<
        IndicatorFilterT<Aggregation>[]
    >([]);
    const [metricsFilter, setMetricsFilter] = useState<string[]>([]);
    const [integrationsFilter, setIntegrationsFilter] = useState<
        IndicatorFilterT<string>[]
    >([]);
    const [vizTypesFilter, setVizTypesFilter] = useState<
        IndicatorFilterT<VizType>[]
    >([]);
    const [search, setSearch] = useState('');

    const canCreateIndicator = useIsExploreUser();

    return (
        <StyIndicatorsContainer>
            <HeaderLayout
                title={t('indicators.title')}
                actions={
                    canCreateIndicator ? (
                        <Link to="/explore" target="_blank">
                            <AddButton text={t('indicators.addIndicator')} />
                        </Link>
                    ) : (
                        <></>
                    )
                }
            />
            <StyIndicatorsPageContent>
                <FilterBar
                    aggregationsFilter={aggregationsFilter}
                    integrationsFilter={integrationsFilter}
                    metricsFilter={metricsFilter}
                    search={search}
                    setAggregationsFilter={setAggregationsFilter}
                    setIntegrationsFilter={setIntegrationsFilter}
                    setMetricsFilter={setMetricsFilter}
                    setSearch={setSearch}
                    setVizTypesFilter={setVizTypesFilter}
                    vizTypesFilter={vizTypesFilter}
                />
                <IndicatorsBanners
                    aggregationsFilter={aggregationsFilter}
                    integrationsFilter={integrationsFilter}
                    metricsFilter={metricsFilter}
                    search={search}
                    vizTypesFilter={vizTypesFilter}
                />
            </StyIndicatorsPageContent>
        </StyIndicatorsContainer>
    );
};

export default Indicators;
